// src/utils/adminRequestHandlers.ts
import { NavigateFunction } from "react-router-dom";
import config from "../../config";
import { AdminRequestData } from "./adminRequestTypes";
import logo from "../../Assets/j.png";
import ses from "../../Assets/ses.jpg";
import { authFetch } from "../Security/authFetch";
import { getSignatureLines } from "../emailSignature";
const email = localStorage.getItem("email");
const recipients = ["g.kattan@bcomsat.com"];

const isAdmin = localStorage.getItem("isAdmin") === "true";

const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};
const fetchEmailsWithRole2 = async (): Promise<string[]> => {
  try {
    const response = await authFetch(
      `${config.apiBaseUrl}/api/responsible-person/emails/role2`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch emails");
    }
    const data = await response.json();

    const allEmails = [...data, "g.kattan@bcomsat.com"];
    const uniqueEmails = Array.from(new Set(allEmails));
    return uniqueEmails;
  } catch (err: any) {
    console.error("Email fetch failed:", err);
    return [];
  }
};
export const handleEdit = async (
  data: AdminRequestData,
  navigate: NavigateFunction,
  fetchMessages: () => void
) => {
  console.log("editrrrrr");
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Edited.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }
  if (data) {
    const jackson = ["jacksondoumith006@gmail.com"];
    const isallsite = localStorage.getItem("isAllSite");
    const isallnetwork = localStorage.getItem("isAllNetwork");
    const isalllink = localStorage.getItem("isAllLink");

    const mso = [
      "g.kattan@bcomsat.com",
      "w.wehbe@bcomsat.com",
      "e.moukhaiber@bcomsat.com",
      "n.vanheerden@bcomsat.com",
      "r.mdazevedo@bcomsat.com",
      "r.tuyama@bcomsat.com",
      "g.chouard@bcomsat.com",
      "j.bassante@bcomsat.com",
      "c.nakhle@bcomsat.com",
      "v.digbeu@bcomsat.com",
      "j.sbeit@bcomsat.com",
    ];
    //     try {
    //       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //         },

    //         body: JSON.stringify({
    //           to: mso,
    //           body: `
    //     <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
    //       <p>Hello,</p>

    //       <p>A ticket with ID  ${
    //         data.ticketId
    //       } has been edited with the following comment
    // </p> <br><br>

    //       <strong>Description:</strong> ${data.description ?? ""}<br><br>
    //       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
    //       <p>
    //         <p>Regards,<br><br></p>
    //  <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
    //                 👉 View Change Details
    //               </a>
    //     </p>

    //    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
    //       <tr>
    //         <td style="vertical-align: top; padding-right: 12px;">
    //           <h1 style="
    //             margin: 0;
    //             font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
    //             font-size: 36px;
    // font-style: italic ;
    //             font-weight: 900;
    //             color: #2a1364;
    //             letter-spacing: 0.5px;
    //             text-transform: uppercase;
    //           ">
    //             SES
    //           </h1>
    //         </td>

    //         <td>
    //           <div style="
    //             padding: 12px;
    //             border-left: 4px solid #2a1364;
    //             background-color: #f9f9f9;
    //             color: #2a1364;
    //             font-size: 13px;
    //           ">
    //             <strong>Managed Services Operations</strong><br>
    //             Value-Added Service<br>
    //             Tel. & Whatsapp msg: +41 225521085<br>
    //             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
    //           </div>
    //         </td>
    //       </tr>
    //     </table>
    //     </div>
    //   `,
    //         }),
    //       });
    //     } catch (emailErr) {
    //       console.error("Failed to send email notification:", emailErr);
    //     }
  }

  navigate(`/adminRequest-edit/${data.ticketId}`, {
    state: { adminRequest: data },
  });
};

export const handleManagerAccept = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  if (!data) return;

  const username = localStorage.getItem("username") || "System";

  try {
    // 1️⃣ Get emails of all users in foruserid
    const userIds = data.foruserid || [];
    const response = await authFetch(
      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIds.join("&id=")}`
    );

    let emails: string[] = [];
    if (response.ok) {
      emails = await response.json();
    }

    const payload = {
      username,
      message: `Request With Id ${data.ticketId} Submitted and approved by line manager.`,
      date: new Date().toISOString(),
      read: false,
      ticketId: data.ticketId,
    };

    await postMessage(payload);

    // if (emails.length > 0) {
    //   await authFetch(`${config.apiBaseUrl}/api/email/send`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({
    //       to: emails,
    //       subject: `Request ID ${data.ticketId} submitted and approved by line manager`,
    //       body: `
    //         <div>
    //           <p>Hello,</p>
    //           <p>The admin request with ID <strong>${
    //             data.ticketId
    //           }</strong> has been accepted.</p>
    //           <p>Description: ${data.description ?? ""}</p>
    //           <p>Closure Code: ${data.closureCode ?? ""}</p>
    //           <p>
    //             <a href="${config.apiBaseUrl}" target="_blank">
    //               👉 View Request Details
    //             </a>
    //           </p>
    //         </div>
    //       `,
    //     }),
    //   });
    // }

    // 4️⃣ Update the admin request (PUT)
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/manageraccept`,
      { method: "PUT" }
    );

    if (updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept admin request");
    }
  } catch (e) {
    console.error("Error while accepting admin request:", e);
  }
};

export const handleManagerReject = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Request With Id ${data.ticketId} Rejected.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    if (data) {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");

      //         const mso = [
      //           "g.kattan@bcomsat.com",
      //           "w.wehbe@bcomsat.com",
      //           "e.moukhaiber@bcomsat.com",
      //           "n.vanheerden@bcomsat.com",
      //           "r.mdazevedo@bcomsat.com",
      //           "r.tuyama@bcomsat.com",
      //           "g.chouard@bcomsat.com",
      //           "j.bassante@bcomsat.com",
      //           "c.nakhle@bcomsat.com",
      //           "v.digbeu@bcomsat.com",
      //           "j.sbeit@bcomsat.com",
      //         ];
      //         try {
      //           await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      //             method: "POST",
      //             headers: {
      //               "Content-Type": "application/json",
      //             },

      //             body: JSON.stringify({
      //               to: mso,
      //               subject: `Change ID ${data.ticketId}  | - In Progress.`,
      //               body: `
      //       <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      //         <p>Hello,</p>

      //         <p>A ticket with ID  ${
      //           data.ticketId
      //         } has been put in progress with the following comment
      //   </p> <br><br>

      //         <strong>Description:</strong> ${data.description ?? ""}<br><br>
      //         <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>

      //         <p>
      //          <p>Regards,<br><br></p>
      //    <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
      //                   👉 View Change Details
      //                 </a>
      //       </p>

      //   <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      //         <tr>
      //           <td style="vertical-align: top; padding-right: 12px;">
      //             <h1 style="
      //               margin: 0;
      //               font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
      //               font-size: 36px;
      //   font-style: italic ;
      //               font-weight: 900;
      //               color: #2a1364;
      //               letter-spacing: 0.5px;
      //               text-transform: uppercase;
      //             ">
      //               SES
      //             </h1>
      //           </td>

      //           <td>
      //             <div style="
      //               padding: 12px;
      //               border-left: 4px solid #2a1364;
      //               background-color: #f9f9f9;
      //               color: #2a1364;
      //               font-size: 13px;
      //             ">
      //               <strong>Managed Services Operations</strong><br>
      //               Value-Added Service<br>
      //               Tel. & Whatsapp msg: +41 225521085<br>
      //               Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
      //             </div>
      //           </td>
      //         </tr>
      //       </table>
      //       </div>
      //     `,
      //             }),
      //           });
      //         } catch (emailErr) {
      //           console.error("Failed to send email notification:", emailErr);
      //         }
    }
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/managerreject`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting adminRequest:", e);
  }
};

export const handleSuperManagerAccept = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  if (!data) return;
  console.log("dataaaaaaaaaa", data);
  const username = localStorage.getItem("username") || "System";
  try {
    // 1️⃣ Get emails of all users in foruserid
    const userIds = data.foruserid || [];
    const response = await authFetch(
      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIds.join("&id=")}`
    );

    let emails: string[] = [];
    if (response.ok) {
      emails = await response.json();
    }

    const payload = {
      username,
      message: `Request With Id ${data.ticketId} Submitted and approved by HR manager.`,
      date: new Date().toISOString(),
      read: false,
      ticketId: data.ticketId,
    };

    await postMessage(payload);

    // if (emails.length > 0) {
    //   await authFetch(`${config.apiBaseUrl}/api/email/send`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify({
    //       to: emails,
    //       subject: `Request ID ${data.ticketId} submitted and approved by line manager`,
    //       body: `
    //         <div>
    //           <p>Hello,</p>
    //           <p>The admin request with ID <strong>${
    //             data.ticketId
    //           }</strong> has been accepted.</p>
    //           <p>Description: ${data.description ?? ""}</p>
    //           <p>Closure Code: ${data.closureCode ?? ""}</p>
    //           <p>
    //             <a href="${config.apiBaseUrl}" target="_blank">
    //               👉 View Request Details
    //             </a>
    //           </p>
    //         </div>
    //       `,
    //     }),
    //   });
    // }

    // 4️⃣ Update the admin request (PUT)
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/supermanageraccept`,
      { method: "PUT" }
    );

    if (updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept admin request");
    }
  } catch (e) {
    console.error("Error while accepting admin request:", e);
  }
};

export const handleSuperManagerReject = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Request With Id ${data.ticketId} Rejected By HR Manager.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    if (data) {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");

      //         const mso = [
      //           "g.kattan@bcomsat.com",
      //           "w.wehbe@bcomsat.com",
      //           "e.moukhaiber@bcomsat.com",
      //           "n.vanheerden@bcomsat.com",
      //           "r.mdazevedo@bcomsat.com",
      //           "r.tuyama@bcomsat.com",
      //           "g.chouard@bcomsat.com",
      //           "j.bassante@bcomsat.com",
      //           "c.nakhle@bcomsat.com",
      //           "v.digbeu@bcomsat.com",
      //           "j.sbeit@bcomsat.com",
      //         ];
      //         try {
      //           await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      //             method: "POST",
      //             headers: {
      //               "Content-Type": "application/json",
      //             },

      //             body: JSON.stringify({
      //               to: mso,
      //               subject: `Change ID ${data.ticketId}  | - In Progress.`,
      //               body: `
      //       <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      //         <p>Hello,</p>

      //         <p>A ticket with ID  ${
      //           data.ticketId
      //         } has been put in progress with the following comment
      //   </p> <br><br>

      //         <strong>Description:</strong> ${data.description ?? ""}<br><br>
      //         <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>

      //         <p>
      //          <p>Regards,<br><br></p>
      //    <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
      //                   👉 View Change Details
      //                 </a>
      //       </p>

      //   <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      //         <tr>
      //           <td style="vertical-align: top; padding-right: 12px;">
      //             <h1 style="
      //               margin: 0;
      //               font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
      //               font-size: 36px;
      //   font-style: italic ;
      //               font-weight: 900;
      //               color: #2a1364;
      //               letter-spacing: 0.5px;
      //               text-transform: uppercase;
      //             ">
      //               SES
      //             </h1>
      //           </td>

      //           <td>
      //             <div style="
      //               padding: 12px;
      //               border-left: 4px solid #2a1364;
      //               background-color: #f9f9f9;
      //               color: #2a1364;
      //               font-size: 13px;
      //             ">
      //               <strong>Managed Services Operations</strong><br>
      //               Value-Added Service<br>
      //               Tel. & Whatsapp msg: +41 225521085<br>
      //               Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
      //             </div>
      //           </td>
      //         </tr>
      //       </table>
      //       </div>
      //     `,
      //             }),
      //           });
      //         } catch (emailErr) {
      //           console.error("Failed to send email notification:", emailErr);
      //         }
    }
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/supermanagerreject`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting adminRequest:", e);
  }
};
export const handleClose = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Closed.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  //   try {
  //     const updRes = await authFetch(
  //       `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/close`,
  //       {
  //         method: "PUT",
  //       }
  //     );

  //     if (updRes.ok) {
  //       fetchMessages();
  //     } else {
  //       console.error("Failed to close the adminRequest.");
  //     }
  //   } catch (err) {
  //     console.error("Error closing adminRequest:", err);
  //     return;
  //   }
  //   try {
  //     const isallsite = localStorage.getItem("isAllSite");
  //     const isallnetwork = localStorage.getItem("isAllNetwork");
  //     const isalllink = localStorage.getItem("isAllLink");

  //     const mso = [
  //       "g.kattan@bcomsat.com",
  //       "w.wehbe@bcomsat.com",
  //       "e.moukhaiber@bcomsat.com",
  //       "n.vanheerden@bcomsat.com",
  //       "r.mdazevedo@bcomsat.com",
  //       "r.tuyama@bcomsat.com",
  //       "g.chouard@bcomsat.com",
  //       "j.bassante@bcomsat.com",
  //       "c.nakhle@bcomsat.com",
  //       "v.digbeu@bcomsat.com",
  //       "j.sbeit@bcomsat.com",
  //     ];
  //     const msgRes = await postMessage(payload);
  //     //console.log("Message sent:", msgRes);
  //   } catch (err) {
  //     console.error("Failed to post message:", err);
  //   }
  //   const recipients = ["g.kattan@bcomsat.com"];

  //   const emailBody = `
  //     <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
  //       <p>Hello,</p>
  //       <p>This Ticket with ID ${
  //         data.ticketId
  //       } was Closed with the following comment:</p><br><br>
  //       <p>

  //           <strong>Description:</strong> ${data.description ?? ""}<br><br>
  //         <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>

  //       </p>
  //       <p>
  //        <p>Regards,<br><br></p>
  //     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
  //                 👉 View Change Details
  //               </a>
  //     </p>
  //   <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
  //       <tr>
  //         <td style="vertical-align: top; padding-right: 12px;">
  //           <h1 style="
  //             margin: 0;
  //             font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
  //             font-size: 36px;
  // font-style: italic ;
  //             font-weight: 900;
  //             color: #2a1364;
  //             letter-spacing: 0.5px;
  //             text-transform: uppercase;
  //           ">
  //             SES
  //           </h1>
  //         </td>

  //         <td>
  //           <div style="
  //             padding: 12px;
  //             border-left: 4px solid #2a1364;
  //             background-color: #f9f9f9;
  //             color: #2a1364;
  //             font-size: 13px;
  //           ">
  //             <strong>Managed Services Operations</strong><br>
  //             Value-Added Service<br>
  //             Tel. & Whatsapp msg: +41 225521085<br>
  //             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
  //           </div>
  //         </td>
  //       </tr>
  //     </table>
  //     </div>
  //   `;

  //   try {
  //     const isallsite = localStorage.getItem("isAllSite");
  //     const isallnetwork = localStorage.getItem("isAllNetwork");
  //     const isalllink = localStorage.getItem("isAllLink");

  //     const mso = [
  //       "g.kattan@bcomsat.com",
  //       "w.wehbe@bcomsat.com",
  //       "e.moukhaiber@bcomsat.com",
  //       "n.vanheerden@bcomsat.com",
  //       "r.mdazevedo@bcomsat.com",
  //       "r.tuyama@bcomsat.com",
  //       "g.chouard@bcomsat.com",
  //       "j.bassante@bcomsat.com",
  //       "c.nakhle@bcomsat.com",
  //       "v.digbeu@bcomsat.com",
  //       "j.sbeit@bcomsat.com",
  //     ];
  //     if (data.ticketCreationDatetime) {
  //       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           to: mso,
  //           subject: `Change ID ${data.ticketId}  | - Closed`,
  //           body: emailBody,
  //         }),
  //       });
  //       //console.log("Customer informed email sent.");
  //     } else if (!isAdmin) {
  //       const emails = await fetchEmailsWithRole2();
  //       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           to: mso,
  //           subject: `Change ID ${data.ticketId}  | - Closed`,
  //           body: emailBody,
  //         }),
  //       });
  //       //console.log("Fallback email sent to role 2 users.");
  //     }
  //     window.location.reload();
  //   } catch (e) {
  //     console.error("Error sending email:", e);
  //   }
};

export const handleReopen = async (
  data: AdminRequestData,
  fetchMessages: () => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Change With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}/reopen`,
      { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating adminRequest:", e);
  }
  if (data.ticketCreationDatetime) {
    try {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");

      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "j.sbeit@bcomsat.com",
        "v.digbeu@bcomsat.com",
      ];
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: mso,
          subject: `Change ID ${data.ticketId}  | - Reopened`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>This Ticket with ID ${
        data.ticketId
      } was Reopened with following comment:</p><br><br>

      





      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      
      <p>
        <p>Regards,<br><br><br></p>
     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
      </p>
    

    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(undefined, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
      // alert(recipients);
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  } else if (!isAdmin) {
    try {
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");

      const mso = [
        "g.kattan@bcomsat.com",
        "w.wehbe@bcomsat.com",
        "e.moukhaiber@bcomsat.com",
        "n.vanheerden@bcomsat.com",
        "r.mdazevedo@bcomsat.com",
        "r.tuyama@bcomsat.com",
        "g.chouard@bcomsat.com",
        "j.bassante@bcomsat.com",
        "c.nakhle@bcomsat.com",
        "v.digbeu@bcomsat.com",
        "j.sbeit@bcomsat.com",
      ];
      const emails = await fetchEmailsWithRole2();
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: mso,
          subject: `Change ID ${data.ticketId}  | - Reopened`,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
           <p>A Ticket with ID ${
             data.ticketId
           } was Reopened with following comment:</p>
                
      





      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      
            <p>
               <p>Regards,<br><br><br><br></p>
           <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
            </p>
         
          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(undefined, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
      //console.log("Email sent: Customer was NOT informed.");
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }
  }
};
